<div *ngIf="document" [ngSwitch]="document.mime" class="file-view-wrapper">
  <pdf-viewer *ngSwitchCase="fileType.pdf"
              [src]="document.link"
              [render-text]="false"
              [autoresize]="true"
              [fit-to-page] = "true"
              [original-size] = "false"
              [style.maxHeight]="maxHeight"
              (after-load-complete)="onLoadComplete()"
              style="display: block;">
  </pdf-viewer>

  <div *ngSwitchDefault class="unknown-type">
    Unknown file type: "{{fileType}}".
  </div>
</div>

<spinner [spinnerShow]="isLoading"></spinner>



// WEBPACK FOOTER //
// /app/src/app/views/announcements/announcement-view/announcement-view.component.html